import { memo } from "react";
import { Link } from "../../../Link";

type SetDefaultFiltersProps = {
  isVisible: boolean,
  clearFilters: () => void,
  className?: string
};
export default memo<SetDefaultFiltersProps>((
  {
    isVisible,
    clearFilters,
    className,
  }) =>
  isVisible ? (
    <Link
      className={className}
      component="button"
      type="button"
      linkType="s"
      onClick={clearFilters}>
      Set default filters
    </Link>
  ) : null,
);
